// CountDes.jsx - Enhanced design projects counter
import React, { useEffect } from 'react';
import { Card, Statistic, Progress, Space, Tag, Tooltip, Typography } from 'antd';
import { FormatPainterOutlined , StarOutlined, SyncOutlined } from '@ant-design/icons';
import { getDesProjects } from '../../features/projects/desprojectSlice';
import { useDispatch, useSelector } from 'react-redux';

const {  Text } = Typography;
const CountDes = () => {
  const { desprojects, loading } = useSelector((state) => state.desprojects);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDesProjects());
  }, [dispatch]);

  // Calculate stats
  const completedProjects = desprojects?.filter(p => p.status === 'completed')?.length || 0;
  const inProgressProjects = desprojects?.filter(p => p.status === 'in-progress')?.length || 0;
  const totalProjects = desprojects?.length || 0;
  const completionRate = totalProjects > 0 ? Math.round((completedProjects / totalProjects) * 100) : 0;

  return (
    <Card 
      className="shadow-medium border border-border-light rounded-xl bg-white hover:shadow-hard transition-all duration-300 h-full"
      bodyStyle={{ padding: '24px' }}
      loading={loading}
    >
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-accent-orange to-orange-600 rounded-full flex items-center justify-center">
            <FormatPainterOutlined  className="text-2xl text-white" />
          </div>
        </div>
        
        <Statistic
          title={
            <span className="text-text-secondary font-medium text-sm uppercase tracking-wide">
              Design Projects
            </span>
          }
          value={totalProjects}
          valueStyle={{
            color: '#f97316',
            fontSize: '3rem',
            fontWeight: 'bold',
            fontFamily: 'Montserrat'
          }}
        />

        <Space direction="vertical" size="small" className="w-full mt-4">
          <div className="flex justify-between items-center">
            <Text className="text-text-secondary text-sm">Completion Rate</Text>
            <Text className="text-accent-orange font-semibold">{completionRate}%</Text>
          </div>
          <Progress 
            percent={completionRate} 
            strokeColor="#f97316"
            trailColor="#f1f5f9"
            strokeWidth={8}
            showInfo={false}
          />
          
          <div className="flex justify-between mt-3">
            <Tooltip title="Completed Projects">
              <Tag color="green" className="flex items-center space-x-1">
                <StarOutlined />
                <span>{completedProjects}</span>
              </Tag>
            </Tooltip>
            <Tooltip title="In Progress">
              <Tag color="orange" className="flex items-center space-x-1">
                <SyncOutlined />
                <span>{inProgressProjects}</span>
              </Tag>
            </Tooltip>
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default CountDes;